module.exports = __webpack_public_path__ + "static/media/loading.495d5246.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = 1066
// module chunks = 0